import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PDFViewerPage from './PDFViewerPage';
import HowToUse from './HowToUse';
import Notices from './Notices';
import DemoTests from './DemoTests';
import OurExams from './OurExams';
import FeaturedExams from './FeaturedExams';
import { GoPin } from "react-icons/go";
import WhyChooseUs from './WhyChooseUs';
import CTAPage from './CTAPage';
import { FaTelegramPlane, FaWhatsapp, FaBook, FaVideo, FaBell } from 'react-icons/fa';
import HeroImage from '../assets/logo2.jpeg';
import StudyImage from '../assets/StudyImage.jpg';
import { FaBullhorn } from "react-icons/fa6";
import { SiTelegram, SiWhatsapp } from 'react-icons/si';
import videoImage from '../assets/videoImage.png';
import HeroBg from '../assets/bgpic.jpg';
import { sendApiRequest } from '../utils/api';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const { user } = useAuth();
  const [isClient, setIsClient] = useState(false);
  const [NoticeData, setNoticeData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setIsClient(true);
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const fetchNotices = async () => {
    try {
      const response = await sendApiRequest('api/admin/notices', {}, 'GET');
      setNoticeData(response.data);
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white font-[montserrat]">
      {/* Hero Section */}
      {/* ================= HERO SECTION ================= */}
      <div
        className="relative w-full sm:min-h-[55vh] md:min-h-[50vh]
  flex flex-col items-center justify-center text-white px-4 pb-12"
        style={{
          backgroundImage: `linear-gradient(rgba(42, 43, 44, 0.75), rgba(33, 34, 37, 0.85)), url(${HeroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >


        {/* Logo */}
        <div className="w-20 h-20 md:w-36 md:h-36 rounded-full bg-white shadow-2xl
                  flex items-center justify-center overflow-hidden mb-3">
          <img
            src={HeroImage}
            alt="Hero Logo"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Title */}
        <h1 className="text-xl md:text-2xl font-extrabold tracking-wide text-center">
          SHORTHAND SOFTWARE
        </h1>

        {/* Subtitle */}
        <p className="text-sm md:text-lg font-semibold text-gray-200">
          Exam Wala Software
        </p>

        {/* ================= FLOATING SOCIAL LINKS ================= */}
        <div className="absolute -bottom-14 left-1/2 -translate-x-1/2 w-full px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl
                    grid grid-cols-2 sm:gap-4 sm:p-4">

            {/* Telegram */}
            <a
              href="https://t.me/your_telegram_username"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-4 py-3 rounded-lg
                   hover:bg-gray-50 transition"
            >
              <SiTelegram className="text-blue-500" size={42} />
              <div>
                <p className="font-bold text-sm text-gray-800">
                  Telegram Group
                </p>
                <span className="inline-block mt-1 text-xs text-white
                           bg-blue-500 px-3 py-1 rounded-md">
                  Join Now
                </span>
              </div>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/your_whatsapp_number"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-4 py-3 rounded-lg
                   hover:bg-gray-50 transition"
            >
              <SiWhatsapp className="text-green-500" size={40} />
              <div>
                <p className="font-bold text-sm text-gray-800">
                  WhatsApp Number
                </p>
                <span className="inline-block mt-1 text-xs text-white
                           bg-green-500 px-3 py-1 rounded-md">
                  Join Now
                </span>
              </div>
            </a>

          </div>
        </div>
      </div>

      {/* ================= BELOW SECTION ================= */}
      <div className="bg-[#f5f7fb] pt-20 pb-6">
        <div className="max-w-7xl mx-auto px-4">

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2">

            {/* Study Materials */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden text-center
                      hover:shadow-md transition">
              <div className="h-36 bg-[#0f2a5f] flex items-center justify-center">
                <img src={StudyImage} alt="Study Materials" className="h-24" />
              </div>
              <div className="py-4 px-3">
                <h3 className="font-bold text-gray-900">
                  Study Materials
                </h3>
                <p className="text-sm text-gray-500">
                  Stenography Papers
                </p>
              </div>
            </div>

            {/* Tutorials */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden text-center
                      hover:shadow-md transition cursor-pointer" onClick={() => navigate('/how-to-use')}>
              <div className="h-36 bg-[#0f2a5f] flex items-center justify-center">
                <img src={videoImage} alt="Tutorials" className="h-24" />
              </div>
              <div className="py-4 px-3">
                <h3 className="font-bold text-gray-900">
                  Tutorials
                </h3>
                <p className="text-sm text-gray-500">
                  Stenography Learn Tips
                </p>
              </div>
            </div>

            {/* Notice Board */}
            <div className="col-span-2 lg:col-span-1 bg-white rounded-xl shadow-md p-5">
              <div className="flex items-center justify-center gap-3 mb-4">
                <FaBullhorn className="text-green-500" size={28} />
                <h3 className="font-semibold text-gray-900">
                  Notice Board
                </h3>
              </div>

              <ul className="space-y-4">
                {NoticeData.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-2 border-b pb-2 last:border-none"
                  >
                    <GoPin className="text-yellow-500 mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-xs text-gray-500">
                        {new Date(item.date).toLocaleDateString('en-IN')}
                      </p>

                      <p className="text-sm font-semibold text-gray-800">
                        {item.title}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      </div>






      {/* Other Sections */}
      <div className="mt-2">
        <div className="">
          <OurExams />
          <FeaturedExams />
          <DemoTests />
          <WhyChooseUs />
          <CTAPage />
        </div>
      </div>
    </div>
  );
};

export default Home;